import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/apiService";

export const GetOneTechnicalReportNotes = createAsyncThunk(
  "GetOneTechnicalReportNotes/GetOneTechnicalReportNotes",
  async (pR_TechnicalReportNotesId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_TechnicalReportNotes/GetPR_TechnicalReportNotesData",
        {
          pR_TechnicalReportNotesId: pR_TechnicalReportNotesId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const UpdateIsActive = createAsyncThunk(
  "UpdateIsActive/UpdateIsActive",
  async (TechnicalReportNotesDataData, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_TechnicalReportNotes/UpdateIsAvtivePR_TechnicalReportNotesData",
        {
          pR_TechnicalReportNotesId:
            TechnicalReportNotesDataData.pR_TechnicalReportNotesId,
          isActive: TechnicalReportNotesDataData.isActive,
          pR_ReportsStagesGuid:
            TechnicalReportNotesDataData.pR_ReportsStagesGuid,
          pR_NotesTableId: TechnicalReportNotesDataData.pR_NotesTableId,
          notes: TechnicalReportNotesDataData.notes,
          timeAndDate: TechnicalReportNotesDataData.timeAndDate,
          incrementNumber: TechnicalReportNotesDataData.incrementNumber,
          canEdit: TechnicalReportNotesDataData.canEdit,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const UpdateCanEdit = createAsyncThunk(
  "UpdateCanEdit/UpdateCanEdit",
  async (TechnicalReportNotesDataData, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_TechnicalReportNotes/UpdateCanEditPR_TechnicalReportNotesData",
        {
          pR_TechnicalReportNotesId:
            TechnicalReportNotesDataData.pR_TechnicalReportNotesId,
          isActive: TechnicalReportNotesDataData.isActive,
          pR_ReportsStagesGuid:
            TechnicalReportNotesDataData.pR_ReportsStagesGuid,
          pR_NotesTableId: TechnicalReportNotesDataData.pR_NotesTableId,
          notes: TechnicalReportNotesDataData.notes,
          timeAndDate: TechnicalReportNotesDataData.timeAndDate,
          incrementNumber: TechnicalReportNotesDataData.incrementNumber,
          canEdit: TechnicalReportNotesDataData.canEdit,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const DeleteTechnicalReportNotes = createAsyncThunk(
  "DeleteTechnicalReportNotes/DeleteTechnicalReportNotes",
  async (pR_TechnicalReportNotesId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_TechnicalReportNotes/DeletePR_TechnicalReportNotesData",
        {
          pR_TechnicalReportNotesId: pR_TechnicalReportNotesId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const GetListTechnicalReportNotes = createAsyncThunk(
  "GetListTechnicalReportNotes/GetListTechnicalReportNotes",
  async (pR_ReportsStagesGuid, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_TechnicalReportNotes/GetPR_TechnicalReportNotesListData",
        {
          pR_ReportsStagesGuid: pR_ReportsStagesGuid,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AddTechnicalReportNotesData = createAsyncThunk(
  "AddTechnicalReportNotesData/AddTechnicalReportNotesData",
  async (TechnicalReportNotesDataData, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_TechnicalReportNotes/AddPR_TechnicalReportNotesData",
        {
          pR_NotesTableId: TechnicalReportNotesDataData.pR_NotesTableId,
          notes: TechnicalReportNotesDataData.notes,
          timeAndDate: TechnicalReportNotesDataData.timeAndDate,
          incrementNumber: TechnicalReportNotesDataData.incrementNumber,
          canEdit: TechnicalReportNotesDataData.canEdit,
          pR_ReportsStagesGuid:
            TechnicalReportNotesDataData.pR_ReportsStagesGuid,
          isActive: TechnicalReportNotesDataData.isActive,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "addJobOpportun");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const ValidateTechnicalReportNotes = createAsyncThunk(
  "ValidateTechnicalReportNotes/ValidateTechnicalReportNotes",
  async (TechnicalReportNotesData, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_TechnicalReportNotes/ValidatePR_TechnicalReportNotesData",
        {
          pR_NotesTableId: TechnicalReportNotesData.pR_NotesTableId,
          notes: TechnicalReportNotesData.notes,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      if (response.data.success === true) {
        const arrayValidate = response.data.result.map((ele, ind) => {
          return ele.code;
        });
        return arrayValidate; // Return the extracted data
      }
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const TechnicalReportNotes = createSlice({
  name: "TechnicalReportNotes",
  initialState: {
    OneTechnicalReportNotes: {},
    loadingOneTechnicalReportNotes: false,
    errorOneTechnicalReportNotes: null,

    CanEditTechnicalReportNotes: {},
    loadingCanEditTechnicalReportNotes: false,
    errorCanEditTechnicalReportNotes: null,

    IsActiveTechnicalReportNotes: {},
    loadingIsActiveTechnicalReportNotes: false,
    errorIsActiveTechnicalReportNotes: null,

    AddTechnicalReportNotes: {},
    loadingAddTechnicalReportNotes: false,
    errorAddTechnicalReportNotes: null,

    DeleteTechnicalReportNotes: {},
    loadingDeleteTechnicalReportNotes: false,
    errorDeleteTechnicalReportNotes: null,

    ListTechnicalReportNotes: {},
    loadingListTechnicalReportNotes: false,
    errorListTechnicalReportNotes: null,

    TechnicalReportNotesValidate: [],
    loadingTechnicalReportNotesValidate: false,
    errorTechnicalReportNotesValidate: null,
  },
  reducers: {
    restValidateTechnicalReportNotes: (state, action) => {
      state.TechnicalReportNotesValidate = [];
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(GetOneTechnicalReportNotes.pending, (state, action) => {
        state.loadingOneTechnicalReportNotes = true;
        state.OneTechnicalReportNotes = action.payload;
        state.errorOneTechnicalReportNotes = null;
      })
      .addCase(GetOneTechnicalReportNotes.fulfilled, (state, action) => {
        state.loadingOneTechnicalReportNotes = false;
        state.OneTechnicalReportNotes = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetOneTechnicalReportNotes.rejected, (state, action) => {
        state.loadingOneTechnicalReportNotes = false;
        state.errorOneTechnicalReportNotes = action.payload;
      })
      .addCase(UpdateIsActive.pending, (state, action) => {
        state.loadingIsActiveTechnicalReportNotes = true;
        state.IsActiveTechnicalReportNotes = action.payload;
        state.errorIsActiveTechnicalReportNotes = null;
      })
      .addCase(UpdateIsActive.fulfilled, (state, action) => {
        state.loadingIsActiveTechnicalReportNotes = false;
        state.IsActiveTechnicalReportNotes = action.payload; // Assuming payload has the desired data
      })
      .addCase(UpdateIsActive.rejected, (state, action) => {
        state.loadingIsActiveTechnicalReportNotes = false;
        state.errorIsActiveTechnicalReportNotes = action.payload;
      })
      .addCase(UpdateCanEdit.pending, (state, action) => {
        state.loadingCanEditTechnicalReportNotes = true;
        state.CanEditTechnicalReportNotes = action.payload;
        state.errorCanEditTechnicalReportNotes = null;
      })
      .addCase(UpdateCanEdit.fulfilled, (state, action) => {
        state.loadingCanEditTechnicalReportNotes = false;
        state.CanEditTechnicalReportNotes = action.payload; // Assuming payload has the desired data
      })
      .addCase(UpdateCanEdit.rejected, (state, action) => {
        state.loadingCanEditTechnicalReportNotes = false;
        state.errorCanEditTechnicalReportNotes = action.payload;
      })

      .addCase(DeleteTechnicalReportNotes.pending, (state, action) => {
        state.loadingDeleteTechnicalReportNotes = true;
        state.DeleteTechnicalReportNotes = action.payload;
        state.errorDeleteTechnicalReportNotes = null;
      })
      .addCase(DeleteTechnicalReportNotes.fulfilled, (state, action) => {
        state.DeleteTechnicalReportNotes = false;
        state.DeleteTechnicalReportNotes = action.payload; // Assuming payload has the desired data
      })
      .addCase(DeleteTechnicalReportNotes.rejected, (state, action) => {
        state.loadingDeleteTechnicalReportNotes = false;
        state.errorDeleteTechnicalReportNotes = action.payload;
      })
      .addCase(GetListTechnicalReportNotes.pending, (state, action) => {
        state.loadingListTechnicalReportNotes = true;
        state.ListTechnicalReportNotes = action.payload;
        state.errorListTechnicalReportNotes = null;
      })
      .addCase(GetListTechnicalReportNotes.fulfilled, (state, action) => {
        state.loadingListTechnicalReportNotes = false;
        state.ListTechnicalReportNotes = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetListTechnicalReportNotes.rejected, (state, action) => {
        state.loadingListTechnicalReportNotes = false;
        state.errorListTechnicalReportNotes = action.payload;
      })
      .addCase(ValidateTechnicalReportNotes.pending, (state, action) => {
        state.loadingTechnicalReportNotesValidate = true;
        state.TechnicalReportNotesValidate = action.payload;
        state.errorTechnicalReportNotesValidate = null;
      })
      .addCase(ValidateTechnicalReportNotes.fulfilled, (state, action) => {
        state.loadingTechnicalReportNotesValidate = false;
        state.TechnicalReportNotesValidate = action.payload; // Assuming payload has the desired data
      })
      .addCase(ValidateTechnicalReportNotes.rejected, (state, action) => {
        state.loadingTechnicalReportNotesValidate = false;
        state.errorTechnicalReportNotesValidate = action.payload;
      })
      .addCase(AddTechnicalReportNotesData.pending, (state, action) => {
        state.loadingAddTechnicalReportNotes = true;
        state.AddTechnicalReportNotes = action.payload;
        state.errorAddTechnicalReportNotes = null;
      })
      .addCase(AddTechnicalReportNotesData.fulfilled, (state, action) => {
        state.loadingAddTechnicalReportNotes = false;
        state.AddTechnicalReportNotes = action.payload; // Assuming payload has the desired data
      })
      .addCase(AddTechnicalReportNotesData.rejected, (state, action) => {
        state.loadingAddTechnicalReportNotes = false;
        state.errorAddTechnicalReportNotes = action.payload;
      });
  },
});
export const { restValidateTechnicalReportNotes } =
  TechnicalReportNotes.actions;
export default TechnicalReportNotes.reducer;
